import React, { ReactElement } from 'react'
import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import { NextSeo } from 'next-seo'
import Layout from '../components/Layout'
import LatestListingCarousel from '../components/home/carousel/LatestListingCarousel'
import MoreAboutBento from '../components/home/bento/MoreAboutBento'
import DashboardPreviewCard from '../components/home/dashboard-preview/DashboardPreviewCard'
import PromoBanner from '../components/discount/PromoBanner'
import { isPromoActive } from '../lib/utils/promo'

function HomePage() {
  const { t } = useTranslation('home')
  const isPromo = isPromoActive()

  return (
    <>
      <NextSeo
        title={t('seo.title') || ''}
        description={t('seo.description') || ''}
      />
      <div>
        {isPromo ? (
          <div className="pb-3">
            <PromoBanner />
          </div>
        ) : null}
        <div>
          <LatestListingCarousel />
        </div>
        <div className="pt-3">
          <DashboardPreviewCard />
        </div>
        <div className="mt-3">
          <MoreAboutBento />
        </div>
      </div>
    </>
  )
}

HomePage.getLayout = (page: ReactElement) => {
  return <Layout>{page}</Layout>
}

export default HomePage

export async function getServerSideProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'home',
        'common',
        'originals/global',
      ])),
    },
  }
}
